module.exports = __webpack_public_path__ + "img/NassPOS.3beba4f3.png";